<template>
  <div class="diff-container">
    <!-- 文件路径 -->
    <div class="file-header">
      <span class="old-file float-left">{{ data.OldPath }}</span>
      <span class="arrow float-left"  v-if="data.OldPath != data.NewPath">→</span>
      <span class="new-file float-left" v-if="data.OldPath != data.NewPath">{{ data.NewPath }}</span>
      <div class="del">
            -{{ diffdel }}
        </div>
        <div class="add">
           +{{ diffadd }}
        </div>
    </div>
    <div style="overflow: hidden; " >
    
       
    </div>
    <!-- 分栏对比 -->
    <div class="diff-columns">
      <!-- 旧版本 -->
      <div class="diff-pane old">
        <div v-for="(line, index) in oldLines" :key="'old'+index" 
             :class="lineClasses(line)" class="line">
          <span class="line-number">{{ line.oldNumber }}</span>
          <span class="content">{{ line.content }}</span>
        </div>
      </div>

      <!-- 新版本 -->
      <div class="diff-pane new">
        <div v-for="(line, index) in newLines" :key="'new'+index" 
             :class="lineClasses(line)" class="line">
          <span class="line-number">{{ line.newNumber }}</span>
          <span class="content">{{ line.content }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      diffadd:0,
      diffdel:0,
    }
  },
  computed: {
    parsedDiff() {
      const lines = this.data.Diff.split('\n')
      let oldLineNum = 1, newLineNum = 1
      const results = []
      // let lines = linearr.filter(item => item !== '\\ No newline at end of file');
      // 解析 @@ 元数据行（示例：@@ -1,3 +1,5 @@）
      const metaLine = lines.find(line => line.startsWith('@@'))
      if (metaLine) {
        const match = metaLine.match(/@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@/)
        if (match) {
          oldLineNum = parseInt(match[1])
          newLineNum = parseInt(match[3])
        }
      }
     
      lines.forEach((line,index) => {
        if (line.startsWith('-')) {
          results.push({
            type: 'old',
            content: line.slice(1),
            oldNumber: oldLineNum++,
            newNumber: null
          })
          this.diffdel ++
        } else if (line.startsWith('+')) {
          // console.log(lines[index-1]);
          //用于判断是否是新增的行，没有任何删除的行，给旧版添加空行
          if((!lines[index-1].startsWith('+') && !lines[index-1].startsWith('\\ No newline at end of file') && !lines[index-1].startsWith('-')) ){
            results.push({
            type: 'old',
            content: '',
            oldNumber: '|',
            newNumber: null
          })
          }
          results.push({
            type: 'new',
            content: line.slice(1),
            oldNumber: null,
            newNumber: newLineNum++
          })
          this.diffadd ++
        } else {
          // 未改动的行
          if(!line.startsWith('@@') && !line.startsWith('\\ No newline at end of file')){
            results.push({
            type: 'context',
            content: line.replace(/^ /, ''),
            oldNumber: oldLineNum++,
            newNumber: newLineNum++
          })
         }
        
        }
      })
      // console.log(results);
      
      return results
    },
    oldLines() {
      return this.parsedDiff.filter(line => line.type !== 'new')
    },
    newLines() {
      return this.parsedDiff.filter(line => line.type !== 'old')
    }
  },
  methods: {
    lineClasses(line) {
      return {
        'deleted': line.type === 'old',
        'added': line.type === 'new',
        'context': line.type === 'context'
      }
    }
  }
}
</script>

<style scoped>

.diff-container {
  border: 1px solid #e1e4e8;
  border-radius: 6px;
}

.file-header {
  padding: 8px 16px;
  background: #f6f8fa;
  border-bottom: 1px solid #e1e4e8;
  overflow: hidden;
}

.diff-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow-x: auto;
}

.diff-pane {
  padding: 8px 0;
}

.line {
  display: flex;
  font-family: monospace;
  padding: 2px 8px;
}

.line-number {
  min-width: 40px;
  padding-right: 8px;
  color: #666;
  user-select: none;
}

.deleted {
  background: #fff0f0;
  color: #cb2431;
}

.added {
  background: #f0fff4;
  color: #22863a;
}

.context {
  color: #24292e;
}

.old {
  border-right: 1px solid #e1e4e8;
}
.del{
  color: #cb2431;
  font-size: 0.08rem;
  font-weight: bold;
  float: left;
  width: 0.3rem;
  background: #ef99a0;
  text-align: center;
  border-radius: 15px;
  margin-left: 0.1rem;
}
.add{
  color: #22863a;
  font-size: 0.08rem;
  font-weight: bold;
  float: left;
  width: 0.3rem;
  background: #7eb88b;
  text-align: center;
  border-radius: 15px;
  margin-left: 0.04rem;
}

</style>